export default class ClearSnippetRevisionsStore {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetRevisions.set([]);
  }
}
